import React, { useState, useEffect } from 'react'
import { Box, Typography, TextField, Button, IconButton } from '@mui/material'
import UserLayout from '../../layouts/UserLayout'
import { apiBase } from '../../services/apiBase'
import { api } from '../../utils/api'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'
import { mainGreen } from '../../utils/color'

function Configuration() {
	const navigate = useNavigate()
	const [config, setConfig] = useState({
		commissionRate: 0,
		buyRate: 0,
	})

	// Fetch current config
	useEffect(() => {
		const fetchConfig = async () => {
			try {
				const response = await apiBase.get(api.ZALO_MINI_APP_CONFIG)

				if (response) {
					setConfig({
						commissionRate: response.commissionRate || 0,
						buyRate: response.buyRate || 0,
					})
				}
			} catch (error) {
				console.error('Error fetching config:', error)
				alert('Không thể tải cấu hình. Vui lòng thử lại!')
			}
		}

		fetchConfig()
	}, [])

	const handleChange = (event) => {
		const { name, value } = event.target
		setConfig((prev) => ({
			...prev,
			[name]: value,
		}))
	}

	const handleSubmit = async () => {
		try {
			const response = await apiBase.post(api.ZALO_MINI_APP_UPDATE_CONFIG, {
				commissionRate: parseFloat(config.commissionRate),
				buyRate: parseFloat(config.buyRate),
			})

			if (response.data) {
				alert('Cập nhật đơn hàng thành công!')
			}
		} catch (error) {
			console.error('Error updating config:', error)
			alert('Có lỗi xảy ra khi cập nhật đơn hàng. Vui lòng thử lại!')
		}
	}

	return (
		<UserLayout>
			<Box sx={{ bgcolor: '#fff', minHeight: '100vh', maxWidth: '992px', margin: '0 auto' }}>
				{/* Header */}
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 2,
						p: 2,
						background: '#fff',
						borderBottom: '1px solid #e0e0e0',
						position: 'sticky',
						top: 0,
						zIndex: 1000,
					}}>
					<IconButton onClick={() => navigate(-1)}>
						<ArrowBackIcon />
					</IconButton>
					<Typography variant='h6' sx={{ flex: 1, textAlign: 'left' }}>
						Cấu hình
					</Typography>
				</Box>

				{/* Form Container */}
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						pt: 4,
					}}>
					<Box sx={{ width: '100%', maxWidth: 400, p: 2 }}>
						<Box sx={{ mb: 3 }}>
							<TextField
								fullWidth
								label='Commission Rate'
								name='commissionRate'
								value={config.commissionRate}
								onChange={handleChange}
								type='number'
								variant='outlined'
								inputProps={{
									step: '0.01',
									min: '0',
									max: '1',
								}}
							/>
						</Box>

						<Box sx={{ mb: 3 }}>
							<TextField
								fullWidth
								label='Buy Rate'
								name='buyRate'
								value={config.buyRate}
								onChange={handleChange}
								type='number'
								variant='outlined'
								inputProps={{
									step: '0.01',
									min: '0',
									max: '1',
								}}
							/>
						</Box>

						<Button
							fullWidth
							variant='contained'
							sx={{
								bgcolor: mainGreen,
								'&:hover': { bgcolor: '#009F47' },
								borderRadius: '8px',
								py: 1.5,
							}}
							onClick={handleSubmit}>
							Cập nhật đơn hàng
						</Button>
					</Box>
				</Box>
			</Box>
		</UserLayout>
	)
}

export default Configuration
